import styled from "styled-components";
import { colors } from "../../components/helpers/functions";

export const BoxContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    .header{
        width: 100%;
        img{
            width: 100%;
            float: left;
        }
    }
    .box{
        width: 100%;
        .inner{
            padding: 10vw 8vw;
            .title{
                font-size: 8.5vw;
                font-weight: 800;
            }
            .description{
                font-size: 3.7vw;
                line-height: 5.2vw;
                font-weight: 500;
                //margin-top: 3.5vw;
                //margin-bottom: 30px;
            }
        }
        .image{
            width: 100%;
            img{
                float: left;
                width: 100%;
            }
        }
    }

    .back_marron_tierra{
        background-color: rgba(${colors.marron_tierra}, 1);
    }
    .back_verde_brocoli{
        background-color: rgba(${colors.verde_brocoli}, 1);
    }
    .back_verde_acelga{
        background-color: rgba(${colors.verde_acelga}, 1);
    }
    .back_azul_agua{
        background-color: rgba(${colors.azul_agua}, 1);
    }
    .back_naranja_pimiento{
        background-color: rgba(${colors.naranja_pimiento}, 1);
    }
    .back_amarillo_banana{
        background-color: rgba(${colors.amarillo_banana}, 1);
    }
    .back_blanco_huevo{
        background-color: rgba(${colors.blanco_huevo}, 1);
    }
    .back_trebol{
        background-color: rgba(${colors.trebol}, 1);
    }

    .text_marron_tierra{
        color: rgba(${colors.marron_tierra}, 1);
    }
    .text_verde_brocoli{
        color: rgba(${colors.verde_brocoli}, 1);
    }
    .text_verde_acelga{
        color: rgba(${colors.verde_acelga}, 1);
    }
    .text_azul_agua{
        color: rgba(${colors.azul_agua}, 1);
    }
    .text_naranja_pimiento{
        color: rgba(${colors.naranja_pimiento}, 1);
    }
    .text_amarillo_banana{
        color: rgba(${colors.amarillo_banana}, 1);
    }
    .text_blanco_huevo{
        color: rgba(${colors.blanco_huevo}, 1);
    }
    .text_trebol{
        color: rgba(${colors.trebol}, 1);
    }
`